// Tiny i18n dictionary for Holy Flowy
export const dict = {
  id: {
    nav_home: "Beranda",
    nav_shop: "Produk",
    nav_about: "Tentang",
    nav_admin: "Admin",
    cart: "Keranjang",
    add_to_cart: "Tambahkan ke Keranjang",
    buy_now: "Beli Sekarang",
    featured: "Koleksi Pilihan",
    all_products: "Semua Produk",
    handmade_with_love: "Handmade with Love",
    free_shipping_promo: "Gratis ongkir Jabodetabek min. belanja Rp500.000",
    checkout: "Checkout",
    continue_shopping: "Lanjut Belanja",
    your_cart: "Keranjang Anda",
    empty_cart: "Keranjang masih kosong",
    subtotal: "Subtotal",
    shipping: "Ongkos Kirim",
    total: "Total",
    quantity: "Jumlah",
    shop_now: "Belanja Sekarang",
    view_details: "Lihat Detail",
    contact: "Kontak",
    follow_us: "Ikuti Kami",
    secure_payment: "Pembayaran Aman",
    payment_methods: "Metode Pembayaran",
    shipping_methods: "Jasa Kirim",
    customer_info: "Data Pengiriman",
    full_name: "Nama Lengkap",
    email: "Email",
    phone: "No. HP / WhatsApp",
    address: "Alamat Lengkap",
    city: "Kota",
    province: "Provinsi",
    postal_code: "Kode Pos",
    country: "Negara",
    notes: "Catatan (opsional)",
    select_courier: "Pilih Jasa Kirim",
    select_payment: "Pilih Pembayaran",
    place_order: "Buat Pesanan",
    order_success: "Pesanan Berhasil Dibuat",
    order_number: "Nomor Pesanan",
    pay_now: "Bayar Sekarang",
    simulate_payment: "Simulasikan Pembayaran Sukses",
    paid: "Lunas",
    pending: "Menunggu Pembayaran",
    qris_pay: "Scan QRIS",
    va_pay: "Virtual Account",
    cc_pay: "Kartu Kredit",
    ewallet_pay: "E-Wallet",
    out_of_stock: "Stok habis",
    stock: "stok",
    login: "Masuk",
    logout: "Keluar",
    dashboard: "Dashboard",
    products: "Produk",
    banners: "Banner",
    orders: "Pesanan",
    settings: "Pengaturan",
  },
  en: {
    nav_home: "Home",
    nav_shop: "Products",
    nav_about: "About",
    nav_admin: "Admin",
    cart: "Cart",
    add_to_cart: "Add to Cart",
    buy_now: "Buy Now",
    featured: "Featured Collection",
    all_products: "All Products",
    handmade_with_love: "Handmade with Love",
    free_shipping_promo: "Free shipping in Jabodetabek for orders over Rp500,000",
    checkout: "Checkout",
    continue_shopping: "Continue Shopping",
    your_cart: "Your Cart",
    empty_cart: "Your cart is empty",
    subtotal: "Subtotal",
    shipping: "Shipping",
    total: "Total",
    quantity: "Quantity",
    shop_now: "Shop Now",
    view_details: "View Details",
    contact: "Contact",
    follow_us: "Follow Us",
    secure_payment: "Secure Payment",
    payment_methods: "Payment Methods",
    shipping_methods: "Couriers",
    customer_info: "Shipping Details",
    full_name: "Full Name",
    email: "Email",
    phone: "Phone / WhatsApp",
    address: "Full Address",
    city: "City",
    province: "Province / State",
    postal_code: "Postal Code",
    country: "Country",
    notes: "Notes (optional)",
    select_courier: "Select Courier",
    select_payment: "Select Payment",
    place_order: "Place Order",
    order_success: "Order Placed Successfully",
    order_number: "Order Number",
    pay_now: "Pay Now",
    simulate_payment: "Simulate Successful Payment",
    paid: "Paid",
    pending: "Awaiting Payment",
    qris_pay: "Scan QRIS",
    va_pay: "Virtual Account",
    cc_pay: "Credit Card",
    ewallet_pay: "E-Wallet",
    out_of_stock: "Out of stock",
    stock: "in stock",
    login: "Sign In",
    logout: "Sign Out",
    dashboard: "Dashboard",
    products: "Products",
    banners: "Banners",
    orders: "Orders",
    settings: "Settings",
  },
};

export const t = (lang, key) => (dict[lang] && dict[lang][key]) || key;
